import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Rx';
import { RequestAuthorizeThisDeviceDto, RequestCheck2FADto, RequestIsAuthorizedDto, RequestNotifyDto, RequestUpdate2FADto, ResponseAuthorizeThisDeviceDto, ResponseCheck2FADto, ResponseIsAuthorizeDto, ResponseNotifyDto, ResponseUpdate2FADto } from '../dto/sf-authenticator.dto';
import { NestApiProvider } from './../../nest-api';

@Injectable()
export class SfAuthenticatorApi {

    private service: string = '';
    private model: string = 'SfAuthenticator';

    constructor(
        public nestApiProvider: NestApiProvider
    ) {
    }

    public notify(payload: RequestNotifyDto): Observable<ResponseNotifyDto> {
        const method: string = 'POST';
        const func: string = 'notify';
        const params: any = payload || {};
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request(method, url, params, urlParams, body);
    }

    public check2FA(payload: RequestCheck2FADto): Observable<ResponseCheck2FADto> {
        const method: string = 'POST';
        const func: string = 'check2FA';
        const params: any = payload || {};
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request(method, url, params, urlParams, body);
    }

    public update2FA(payload: RequestUpdate2FADto): Observable<ResponseUpdate2FADto> {
        const method: string = 'POST';
        const func: string = 'update2FA';
        const params: any = payload || {};
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request(method, url, params, urlParams, body);
    }

    public isAuthorized(payload: RequestIsAuthorizedDto): Observable<ResponseIsAuthorizeDto> {
        const method: string = 'POST';
        const func: string = 'isAuthorized';
        const params: any = payload || {};
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request(method, url, params, urlParams, body);
    }

    public authorizeThisDevice(payload: RequestAuthorizeThisDeviceDto): Observable<ResponseAuthorizeThisDeviceDto> {
        const method: string = 'POST';
        const func: string = 'authorizeThisDevice';
        const params: any = payload || {};
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request(method, url, params, urlParams, body);
    }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-authenticator.api.ts